<template>
  <confirmation-modal
    :name="name"
    :close="true"
    :title="$t('OVERLAY_BLOCK_ARE_YOU_A_MEMBER')"
    :confirm="$t('OVERLAY_BLOCK_I_AM_A_MEMBER')"
    :cancel="$t('OVERLAY_BLOCK_I_AM_NOT_A_MEMBER')"
    @confirm="handleRouteOnConfirm"
    @cancel="handleRouteOnCancel"
  >
    <slot></slot>
  </confirmation-modal>
</template>

<script>
import UIMixin from '~/mixins/ui'
import { MEMBER_SESSION_SHOWN } from '~/constants/sitecore-keys'
import ConfirmationModal from '~/components/modal/confirmation'

export const MEMBER_SESSION_MODAL = 'member-session-modal'

export default {
  name: 'MemberSessionModal',

  mixins: [UIMixin],

  components: {
    ConfirmationModal
  },

  props: {
    name: {
      type: String,
      required: true
    },
    routeOnConfirm: {
      type: String,
      required: true
    },
    routeOnCancel: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleRouteOnConfirm () {
      this.setMemberModalShownSession()
      this.$ui.modal.close(this.name)

      this.$login(this.routeOnConfirm)
    },

    handleRouteOnCancel () {
      this.setMemberModalShownSession()
      this.$ui.modal.close(this.name)

      if (this.routeOnCancel) this.$router.push(this.routeOnCancel)
    },

    setMemberModalShownSession () {
      sessionStorage.setItem(MEMBER_SESSION_SHOWN, 'true')
    }
  }
}
</script>
